// import { ToastNotificationContainer } from '@components/cockpit/toast/notification/ToastNotificationContainer';
import { CommonMapLayers } from '@components/map/layers/CommonMapLayers';
import FlightPlanLayer from '@components/map/layers/flightPlans/operational/FlightPlanLayer';
import { PlatformLayer } from '@components/map/layers/platforms/PlatformLayer';
import RoundLayer from '@components/map/layers/round/RoundLayer';
import SelectionLayer from '@components/map/layers/SelectionLayer';
import ZoneLayer from '@components/map/layers/zones/ZoneLayer';
import { useSelectorWithMapId } from '@hooks/useSelectorWithMapId';
import { selectMapDrawModeByMapId } from '@redux/maps/maps.selectors';

import { DrawPolygonLayer } from './layers/draw/polygons/DrawPolygonLayer';
import EngagementLayer from './layers/engagement/EngagementLayer';
import { VertiportLayer } from './layers/vertiports/VertiportLayer';
import MapboxMap from './MapboxMap';

export function LiveMap() {
  const isMapDrawModeOn = useSelectorWithMapId(selectMapDrawModeByMapId);

  // Do not add controls here

  return (
    <MapboxMap>
      <PlatformLayer />
      {isMapDrawModeOn && <DrawPolygonLayer />}
      <ZoneLayer />
      <FlightPlanLayer />
      <RoundLayer />
      <VertiportLayer />
      <CommonMapLayers />
      <EngagementLayer />
      <SelectionLayer />
      {/*<ToastNotificationContainer />*/}
    </MapboxMap>
  );
}
